<me-header [class.hidden]="meService?.isLandingPage"></me-header>
<me-landing-page-header [class.hidden]="!meService.isLandingPage"></me-landing-page-header>
<div class="me-page" [class.isLoading]="appService.isLoading">
    <router-outlet></router-outlet>
</div>
<ng-container *ngIf="!meService.isLandingPage && !meService.isNonMedicalFooter; else meLandingFooter">
    <me-footer></me-footer>
</ng-container>
<ng-template #meLandingFooter>
    <me-landing-page-footer *ngIf="(meService.isLandingPage || !meService.isNonMedicalFooter); else nonMedical"></me-landing-page-footer>

    <ng-template #nonMedical>
        <me-footer-non-medical></me-footer-non-medical>
    </ng-template>
</ng-template>
